module.exports = __webpack_public_path__ + "static/media/person-dolly.9675fbb6.svg";